<div class="contracts-dashboard">
  <div class="header">
    <div class="title-section">
      <h2>Expiring Contracts</h2>
    </div>
    <div class="search-bar-container">
      <div class="search-child">
        <emerald-input
          [label]="'Search'"
          [trailingIcon]="'search'"
          (keyup)="searchContracts($event)"
          [value]="filterValue"
          ><emerald-icon
            *ngIf="filterValue?.length && filterValue.length > 0"
            [icon]="'close'"
            (click)="clearInput()"
          ></emerald-icon>
        </emerald-input>
      </div>
    </div>
  </div>

  <div class="datatable-container">
    <ng-container *ngIf="filteredContracts?.length; else noDataTemplate">
      <emerald-datatable
        [columnDefs]="columnDefs"
        [rowData]="filteredContracts"
        [paginationParams]="paginationParams"
        [maxHeight]="maxTableHeight"
        [customCellTemplate]="{
          name: customNameColumn,
          daysLeft: customDaysLeftColumn,
          action: customActionColumn
        }"
      >
      </emerald-datatable>
    </ng-container>
    <ng-template #noDataTemplate>
      <section class="records-container" aria-label="Records section">
        <div class="empty-state">
          <h2 class="empty-state-title">No Expiring Contracts Found</h2>
          <img
            [src]="imageSrc"
            alt="No records illustration"
            class="empty-state-image"
          />
        </div>
      </section>
    </ng-template>
    <ng-template #customNameColumn let-eachRow="eachRow">
      <div
        class="contractor-name"
        >{{ eachRow?.name }}</div
      >
    </ng-template>
    <ng-template #customDaysLeftColumn let-eachRow="eachRow">
      <span
        [ngClass]="{
          'days-left-red': eachRow.daysLeft <= 15,
          'days-left-orange': eachRow.daysLeft > 15
        }"
      >
        {{ eachRow.daysLeft }} Days
      </span>
    </ng-template>
    <ng-template #customActionColumn let-eachRow="eachRow">
      <div
        class="notify-icon-container disabled"
        title="Send Notification (Disabled)"
      >
        <img
          src="assets/img/notificationmultiple.svg"
          alt="Notify"
          class="notify-icon disabled"
        />
      </div>
    </ng-template>
  </div>
</div>